import React from "react";

import Heading from "@common/components/Heading/Heading";
import { formatDayDuration } from "@common/models/helpers/time/dayDuration";
import { vars } from "@common/styles";
import { Flex } from "@common/styles/reusable/Flex/Flex.styles";
import { ReleaseMetricCard, ReleaseMetricCardBaseProps } from "@main/pages/Release/views/MetricCards/ReleaseMetricCard";
import { format } from "date-fns";

interface ReleaseDateEstimateCardProps extends ReleaseMetricCardBaseProps {
  days: number | null | undefined;
}

const ReleaseDateEstimateCard = ({
  style,
  days,
  score,
  highlight,
  error,
  onMoreClick,
}: ReleaseDateEstimateCardProps) => {
  const releaseDateEstimate = new Date(Date.now() + (days ?? 0) * 24 * 60 * 60 * 1000);

  return (
    <ReleaseMetricCard
      style={style}
      title={"Release date estimate"}
      score={score}
      highlight={highlight}
      error={error}
      onMoreClick={onMoreClick}
    >
      <Flex>
        {days != null ? (
          <>
            {" "}
            <Heading
              heading2
              style={{ marginRight: "1.8rem" }}
              marginBottom={0}
            >{`In ${formatDayDuration(days)}`}</Heading>
            <Heading
              heading3
              style={{ color: vars.colors.grey60 }}
              marginBottom={0}
            >{`🗓️ ${format(releaseDateEstimate, "d MMM yyyy")}`}</Heading>
          </>
        ) : (
          <Heading
            heading2
            style={{ marginRight: "1.8rem" }}
            marginBottom={0}
          >{`n/a`}</Heading>
        )}
      </Flex>
    </ReleaseMetricCard>
  );
};

export { ReleaseDateEstimateCard };
